/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Auth_Error_State_MismatchInputs */

const es_login_auth_error_state_mismatch = /** @type {(inputs: Login_Auth_Error_State_MismatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La sesión de autenticación expiró o es inválida. Por favor, iniciá sesión nuevamente.`)
};

const en_login_auth_error_state_mismatch = /** @type {(inputs: Login_Auth_Error_State_MismatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The authentication session expired or is invalid. Please sign in again.`)
};

/**
* | output |
* | --- |
* | "The authentication session expired or is invalid. Please sign in again." |
*
* @param {Login_Auth_Error_State_MismatchInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const login_auth_error_state_mismatch = /** @type {((inputs?: Login_Auth_Error_State_MismatchInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Auth_Error_State_MismatchInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_login_auth_error_state_mismatch(inputs)
	return en_login_auth_error_state_mismatch(inputs)
});
export { login_auth_error_state_mismatch as "login.auth_error.state_mismatch" }